exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * Foundation for Sites by ZURB\n * Version 6.5.3\n * foundation.zurb.com\n * Licensed under MIT Open Source\n */\n.print-layout {\n  padding: 30px; }\n  .print-layout__logo {\n    width: 150px; }\n", ""]);

// exports
